import { useState } from "react";

export default function CtaDefaultsPanel() {
  const [defaults, setDefaults] = useState({
    prefix: "CTA",
    mask: "CTA-UF-IBGE-NNNNNN",
    autoGenerate: true,
    requirePhoto: true,
    requireCoords: true,
    requireSpecies: true,
    allowUnidentified: false,
    requireValidation: true,
  });

  const toggle = (field: string) => {
    setDefaults((prev) => ({ ...prev, [field]: !prev[field as keyof typeof prev] }));
  };

  return (
    <div className="space-y-5">
      <div className="bg-white rounded-xl border border-background-200/70 p-5">
        <h3 className="text-sm font-semibold text-foreground-900 mb-4">Padrões do código CTA</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block text-xs font-medium text-foreground-600 mb-1">Prefixo do código</label>
            <input type="text" value={defaults.prefix} onChange={(e) => setDefaults((p) => ({ ...p, prefix: e.target.value }))} className="w-full px-3 py-2 text-sm border border-background-200 rounded-lg bg-white text-foreground-900 focus:ring-2 focus:ring-primary-200 focus:border-primary-500 outline-none" />
          </div>
          <div>
            <label className="block text-xs font-medium text-foreground-600 mb-1">Máscara do código</label>
            <input type="text" value={defaults.mask} onChange={(e) => setDefaults((p) => ({ ...p, mask: e.target.value }))} className="w-full px-3 py-2 text-sm border border-background-200 rounded-lg bg-white text-foreground-900 focus:ring-2 focus:ring-primary-200 focus:border-primary-500 outline-none" />
          </div>
        </div>
        <div className="mt-4 p-3 bg-primary-50 rounded-lg border border-primary-200">
          <span className="text-xs text-foreground-500">Exemplo visual: </span>
          <span className="text-sm font-semibold text-primary-800 font-heading">CTA-GO-5208707-000001</span>
        </div>
      </div>

      <div className="bg-white rounded-xl border border-background-200/70 p-5">
        <h3 className="text-sm font-semibold text-foreground-900 mb-4">Requisitos de cadastro</h3>
        <div className="space-y-3">
          <ToggleRow label="Gerar código automaticamente" checked={defaults.autoGenerate} onChange={() => toggle("autoGenerate")} />
          <ToggleRow label="Exigir foto no cadastro" checked={defaults.requirePhoto} onChange={() => toggle("requirePhoto")} />
          <ToggleRow label="Exigir coordenada geográfica" checked={defaults.requireCoords} onChange={() => toggle("requireCoords")} />
          <ToggleRow label="Exigir espécie identificada" checked={defaults.requireSpecies} onChange={() => toggle("requireSpecies")} />
          <ToggleRow label="Permitir cadastro como 'não identificado'" checked={defaults.allowUnidentified} onChange={() => toggle("allowUnidentified")} />
          <ToggleRow label="Exigir validação técnica" checked={defaults.requireValidation} onChange={() => toggle("requireValidation")} />
        </div>
      </div>
    </div>
  );
}

function ToggleRow({ label, checked, onChange }: { label: string; checked: boolean; onChange: () => void }) {
  return (
    <label className="flex items-center justify-between py-2 cursor-pointer">
      <span className="text-sm text-foreground-700">{label}</span>
      <button
        type="button"
        role="switch"
        aria-checked={checked}
        onClick={onChange}
        className={`relative inline-flex h-6 w-11 shrink-0 rounded-full border-2 border-transparent transition-colors focus:outline-none ${checked ? "bg-primary-500" : "bg-foreground-300"}`}
      >
        <span className={`inline-block h-5 w-5 rounded-full bg-white shadow transform transition-transform ${checked ? "translate-x-5" : "translate-x-0"}`} />
      </button>
    </label>
  );
}